var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tooltipWrap"},[_c('div',{staticClass:"tooltipWrap-info"},[_vm._v(" ? ")]),_c('div',{staticClass:"tooltipWrap-balloon"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }